var _path, _path2, _path3, _circle, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserFailure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.2022 66.6501C47.5992 69.6113 43 76.2422 43 83.9473C43 86.7378 45.2621 89 48.0526 89H79.9474C82.7379 89 85 86.7378 85 83.9473C85 76.2422 80.4007 69.6113 73.7978 66.6501C73.4905 66.8885 73.1743 67.1159 72.8497 67.3318C79.3916 70.0107 84 76.4409 84 83.9473C84 86.1855 82.1856 88 79.9474 88H48.0526C45.8144 88 44 86.1855 44 83.9473C44 76.4409 48.6084 70.0107 55.1503 67.3318C54.8257 67.1159 54.5095 66.8885 54.2022 66.6501Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 48C54 42.4771 58.4772 38 64 38C69.5229 38 74 42.4772 74 48V54C74 59.5229 69.5229 64 64 64C58.4772 64 54 59.5228 54 54V48ZM73 48V54C73 58.9706 68.9706 63 64 63C59.0294 63 55 58.9706 55 54V48C55 43.0294 59.0294 39 64 39C68.9706 39 73 43.0294 73 48Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 114C91.6142 114 114 91.6142 114 64C114 36.3858 91.6142 14 64 14C36.3858 14 14 36.3858 14 64C14 91.6142 36.3858 114 64 114ZM64 113C91.062 113 113 91.062 113 64C113 36.938 91.062 15 64 15C36.938 15 15 36.938 15 64C15 91.062 36.938 113 64 113Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 102,
    r: 20,
    fill: "#FF248A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109 95.7778L108.222 95L102 101.222L95.7778 95L95 95.7778L101.222 102L95 108.222L95.7778 109L102 102.778L108.222 109L109 108.222L102.778 102L109 95.7778Z",
    fill: "#37174A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFailure);
export default __webpack_public_path__ + "static/media/user-failure.c1f6dcf6.svg";
export { ForwardRef as ReactComponent };